// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chipHeight[data-v-556a4a10] {\n  height: 24px;\n}", ""]);
// Exports
module.exports = exports;
